export default "__VITE_ASSET__DfvrgIwI__"